
(function () {
	'use strict';

	angular.module(modules.homeModule)
		.controller('StartpageController', startpageController);

	startpageController.$inject = ['$state', '$http', '$scope', '$sce', '$timeout', '$window', 'newsService',
		'tabStateService', 'localStorageService', 'documentService', 'browserService', 'configService'];

	function startpageController($state, $http, $scope, $sce, $timeout, $window, newsService,
		tabStateService, localStorageService, documentService, browserService, configService) {
		var vm = this;
		
		vm.toggleLoadAllNews = localStorageService.getItem('toggleLoadAllNews') || false;
		vm.news = [];
		vm.leftMenuGroups = [];
		vm.rightMenuGroups = [];
		vm.currentPage = -1;
		vm.totalResults = 0;
		vm.maxDisplayPage = NewsGridConfig.maxDisplayPage;
		vm.itemPerPage = NewsGridConfig.pageSize;
		vm.translation = {
			more: globalResources.More,
			showmore: globalResources.Showmore,
			first: globalResources.First,
			last: globalResources.Last,
			newsHeader: globalResources.NewsHeader,
			news: globalResources.News,
			run: globalResources.Run,
			yourReports: globalResources.YourReports,
			searchDocumentTitleOrId: globalResources.SearchDocumentTitleOrId,
			selectTheTypeOfSearch: globalResources.SelectTheTypeOfSearch,
			myReports: globalResources.MyReports,
			processes: globalResources.Processes,
			myPage: globalResources.MyPage
		};

		vm.reportTypes = DEVIATION_REPORTS_TYPES;

		vm.loadAllNews = loadAllNews;
		vm.gotoUrl = gotoUrl;
		vm.collapseHandle = collapseHandle;
		vm.goToNewsDetails = loadNews;
		vm.runReport = runReport;
		vm.enableHomepageSearch = configService.getBool(HandbookConfiguration.EnableHomepageSearch);
		vm.dashboardIframeUrl = $sce.trustAsResourceUrl(HandbookConfiguration.BackendURL + 'dashboard?hideTopBar=true');
		vm.BROWSER_TYPE = BrowserType;
		vm.browserType = browserService.detectBrowserWindow();

		initialize();

		function initialize() {
			vm.isDataAvailable = (HandbookConfiguration.StartpageThemeKey != E.StartpageTheme.StartpageWithNewsAndImage);
			if (vm.toggleLoadAllNews) {
				loadAllNews(localStorageService.getItem('pageIndex'));
			}
			else {
				getNews();
				//add for device
				$timeout(function () {
					newsService.adjustNewsHeight();
					$scope.$apply();
				}, 3000, false);
			}
			getMenuGroups();
			getUserFilterSearches();

			if (HandbookConfiguration.StartpageThemeKey == E.StartpageTheme.StartpageWithProcessAndWidgets) {
				setTimeout(function () {
					$('#processTabTrigger').trigger('click');
				});
            }
		};

		function getUserFilterSearches() {
			return $http.get('/api/Users/GetUserSavedSearches', { params: { searchFilterType: searchFilterTypes.handbookReports } })
				.then(function (response, status, headers, config) {
					if (response.data) {
						response.data.forEach(function (item) {
							var type = getReportType(item.searchFilters);
							item.reportType = getReportTypeText(type);
							item.module = searchFilterTypes.handbookReports;
						});
						vm.saveSearches = response.data;
						getUserFilterSearchesForDeviation();
					}
				});

		}

		function getUserFilterSearchesForDeviation() {
			return $http.get('/api/Users/GetUserSavedSearches', { params: { searchFilterType: searchFilterTypes.deviationReports } })
				.then(function (response, status, headers, config) {
					if (response.data) {
						if (!vm.saveSearches)
							vm.saveSearches = [];

						response.data.forEach(function (item) {
							var type = getReportType(item.searchFilters);
							item.module = searchFilterTypes.deviationReports;
							item.reportType = getReportTypeTextForDeviation(type);
							vm.saveSearches.push(item);
						});
					}
				});

		}

		function getReportType(searchFilters) {
			if (!searchFilters)
				return '';

			var arrSearchFilter = decodeURIComponent(searchFilters).split('&');
			if (arrSearchFilter == null || arrSearchFilter.length <= 0)
				return '';

			for (var i = 0; i < arrSearchFilter.length; i++) {
				var values = arrSearchFilter[i].split('=');
				if (values != null && values.length > 0 && values[0] == 'reportType') {
					return values[1];
				}
			}
			return '';
		}

		function getReportTypeText(type) {
			if (type != '')
				type = parseInt(type);
			switch (type) {
				case 1:
					return globalResources.ReadingReceiptsPerson;
				case 2:
					return globalResources.ReadingReceiptsDocument;
				case 3:
					return globalResources.ReadingReceiptsFolder;
				case 4:
					return globalResources.NumberOfDocumentsPerFolder;
				case 5:
					return globalResources.FolderStatistics;
				case 6:
					return globalResources.NewRevisedDocuments;
				case 7:
					return globalResources.WritePermissionsPerson;
				case 8:
					return globalResources.ApprovePermissionsPerson;
				case 9:
					return globalResources.WritePermissions;
				case 10:
					return globalResources.ApprovePermissions;
				case 11:
					return globalResources.ReadingListsPerson;
				case 12:
					return globalResources.ReadingListDepartment;
				case 13:
					return globalResources.ReadingListClosestLeader;
				case 14:
					return globalResources.ReadingListRole;
				case 15:
					return globalResources.MostReadDocumentsTotal;
				case 16:
					return globalResources.MostReadDocumentsVersion;
				case 17:
					return globalResources.StatusDocumentsPerFolder;
				case 18:
					return globalResources.LeastReadDocumentsTotal;
				case 19:
					return globalResources.LeastReadDocumentsVersion;
				default:
			}

			return '';
		}

		function getReportTypeTextForDeviation(type) {
			if (type != '')
				type = parseInt(type);
			switch (type) {
				case vm.reportTypes.CATEGORY_NUMBER:
					return globalResources.categoryNumberPerStatus;
				case vm.reportTypes.CATEGORY_NUMBER_PER_METATAG:
					return globalResources.metatagCategoryReport;
				case vm.reportTypes.CATEGORY_NUMBER_PER_SUB_CATEGORY:
					return globalResources.subCategoryCategoryReport;
				case vm.reportTypes.CATEGORY_NUMBER_PER_HANDLING_UNIT:
					return globalResources.categoryNumberPerHandlingUnit;
				case vm.reportTypes.CATEGORY_YEAR_AND_MONTH_NUMBER:
					return globalResources.categoryYearAndMonthNumber;
				case vm.reportTypes.CATEGORY_NUMBER_PER_MONTH_PER_YEAR:
					return globalResources.categoryNumberPerMonthPerYear;
				case vm.reportTypes.CATEGORY_SEVERITY_NUMBER:
					return globalResources.categorySeverityNumbers;
				case vm.reportTypes.CATEGORY_KPI:
					return globalResources.category + ' - ' + globalResources.kpi;
				case vm.reportTypes.ACTIONS_NUMBER_AND_TYPE:
					return globalResources.actionsNumberAndType;
				case vm.reportTypes.ACTIONS_NUMBER_PER_MONTH_PER_YEAR:
					return globalResources.actionsNumberPerMonthPerYear;
				case vm.reportTypes.STATISTICS:
					return globalResources.statistics;
				case vm.reportTypes.CATEGORY_COST_PER_YEAR:
					return globalResources.costCategory;
				case vm.reportTypes.CATEGORY_COST_PER_MONTH_PER_YEAR:
					return globalResources.costTypeSumPerMonthPerYear;
				case vm.reportTypes.CATEGORY_CUSTOM_FIELD:
					return globalResources.categoryCustomFieldReport;
				case vm.reportTypes.CATEGORY_EQUIPMENT:
					return globalResources.categoryEquipmentReport;
				default:
			}

			return '';
		}

		function getNews() {
			newsService
				.getNews({ showInModule: E.NewsCategoryShownIn.shownInHandbookFrontend })
				.then(function (result) {
					handleDevicesSize(result.data.length);
					vm.news = result.data;
					if (vm.news.length > 0) {
						vm.news.filter(function (x) {
							if (x.image !== null) {
								newsService
									.getNewsImageById(x.id)
									.then(function (result) {
										if (result.data !== null && result.data.value !== null) {
											if (result.data.id === -1) {
												x.image.value = result.data.value;
											}
											else {
												x.image.value = 'data:image/png;base64,' + result.data.value;
											}
										}
									})
									.catch(function (result) {

									});
							}
						});
					}
					$timeout(function () {
						newsService.adjustNewsHeight();
						$scope.$apply();
					}, 500, false);
				});
		};

		function loadNews(id) {
			user.currentNewsPage = 1;
			newsService
				.updateNewsReadCount(id);
		};

		function loadAllNews(pageIndex, pageSize) {
			if (!vm.toggleLoadAllNews) {
				pageIndex = 1;
			}

			newsService
				.getNewsWithPaging(pageIndex - 1, pageSize || NewsGridConfig.pageSize)
				.then(function (result) {
					vm.news = result.data.news;
					vm.toggleLoadAllNews = true;
					vm.totalResults = result.data.totalResults;
					vm.currentPage = pageIndex;
					localStorageService.setItem('toggleLoadAllNews', true);
					localStorageService.setItem('pageIndex', pageIndex);
				});

			adjustContentPosition();
		};

		function getMenuGroups() {
			$http
				.get(handbookRequests.GetMenuGroups)
				.then(function (result) {
					var menus = result.data;
					var rootMenuId = HandbookConfiguration.MenuId;

					var columns = [];
					for (var i = 0; i < menus.length; i++) {
						if (menus[i].parentItemId == rootMenuId) {
							columns.push(menus[i]);
						}
					}

					var groups = getGroupsPerCoumn(menus, columns);
					groups = getGroupItems(menus, groups);

					vm.menus = groups;
					buildGroupsStyle(vm.menus);

					if (configService.getBool(HandbookConfiguration.CollapseMenuGroups)) {
						collapseMenuGroups();
					}
					vm.isDataAvailable = true;
				})
		};

		function collapseMenuGroups() {
			$timeout(function () {
				for (var i = 0; i < vm.menus.length; i++) {
					for (var j = 0; j < vm.menus[i].groups.length; j++) {
						if (!vm.menus[i].groups[j].expanded) {
							angular.element('#spgroup_' + vm.menus[i].groups[j].itemId).toggleClass('collapsed');
							angular.element('#spgroup_' + vm.menus[i].groups[j].itemId + '_icon').removeClass('collapse-arrow').addClass('collapsed-arrow');
						}
					}
				}
			}, 500, false);
		}

		function getGroupsPerCoumn(menus, columns) {
			var groups = [];
			var index = 0, hasGroupItems = false;
			for (var i = 0; i < columns.length; i++) {
				for (var j = 0; j < menus.length; j++) {
					if (menus[j].parentItemId == columns[i].itemId) {
						hasGroupItems = true;
						if (groups[index] == null) {
							var children = []; children.push(menus[j]);
							groups.push({ groups: children });
						} else {
							groups[index].groups.push(menus[j]);
						}
					}
				}
				if (hasGroupItems) {
					for (var k = 0; k < groups[index].groups.length; k++) {
						menus.splice($.inArray(groups[index].groups[k], menus), 1);
					}
					index += 1;
				}
				hasGroupItems = false;
			}
			return groups;
		}

		function buildGroupsStyle(menus) {
			var length = menus.length;
			var padding = 2, css = '';
			var width = 100 / length - padding;

			switch (length) {
				case 1:
					if (HandbookConfiguration.StartpageThemeKey == E.StartpageTheme.StartpageWithNewsAndImage) {
						css = 'col-md-6 col6res';
					} else {
						css = 'col-md-12';
					}
					break;
				case 2:
					if (HandbookConfiguration.StartpageThemeKey == E.StartpageTheme.StartpageWithNewsAndImage) {
						css = 'col-md-4 col4res';
					} else {
						css = 'col-md-6';
					}
					break;
				case 3:
					css = 'col-md-4';
					break;
				case 4:
					css = 'col-md-3';
					break;
				default:
					css = 'col-md-2';
					break;
			}

			vm.imageCss = css;

			for (var i = 0; i < length; i++) {
				menus[i].style = 'width: ' + width + '%; float: left;';
				menus[i].css = css;
				if (i < length - 1) {
					menus[i].style += 'margin-right: ' + padding + '%;'
				}
			}
		}

		function getGroupItems(menus, groups) {
			for (var i = 0; i < menus.length; i++) {
				for (var j = 0; j < groups.length; j++) {
					for (var k = 0; k < groups[j].groups.length; k++) {
						if (menus[i].parentItemId == groups[j].groups[k].itemId) {
							if (groups[j].groups[k].items == null) {
								var items = []; items.push(menus[i]);
								groups[j].groups[k].items = items;
							} else {
								groups[j].groups[k].items.push(menus[i]);
							}
						}
					}
				}
			}

			return groups;
		}

		function adjustContentPosition() {
			var tabState = tabStateService.getState(tabStateType.homeTabState);
			$timeout(function () {
				tabStateService.adjustContentPosition(tabState, tabStateType.homeTabState);
			}, 0, false);
		};

		function gotoUrl(item, e) {
			var requestUrl = '/api/Menu/SaveClickedCount';
			var request = { itemId: item.itemId };
			if (item.url) {
				$http.post(requestUrl, request);
			}
			if (item.url.indexOf('http') >= 0) {
				if (item.url.indexOf($window.location.hostname) < 0) {
					return;
				}
			}
			if (item.url.indexOf('document/') >= 0) {
				if (item.newWindow != '1') {
					documentService.goToDocument(item.url.substr(item.url.lastIndexOf('/') + 1));
					e.preventDefault();
				}
			} else if (item.url.indexOf('folder/') >= 0) {
				if (item.newWindow != '1') {
					$state.go(handbookActions.FolderAction, { folderId: item.url.substr(item.url.lastIndexOf('/') + 1) });
					e.preventDefault();
				}
			}
		};

		$scope.$watch('vm.currentPage', function (newPage) {
			if (vm.currentPage != -1) {
				loadAllNews(newPage);
			}
		});

		$(window).on('resize', function () {
			handleDevicesSize(vm.news.length);
			$timeout(function () {
				newsService.adjustNewsHeight();
				$scope.$apply();
			}, 500, false);
		});

		function collapseHandle(collapsedFlag) {
			vm.collapsed = collapsedFlag;
		};

		$scope.$on('adjustmentNews', function (e, target) {

			$timeout(function () {
				newsService.adjustNewsHeight()
			}, 500, false);
		});

		function handleDevicesSize(newsLength) {
			var availWidth = screen.availWidth;
			var availHeight = screen.availHeight;

			if (availWidth <= 768) {
				//mobile
				vm.newsItemClass = 'col-xs-12';
			} else {
				switch (newsLength) {
					case 1:
						vm.newsItemClass = 'col-xs-12';
						break;
					case 2:
						vm.newsItemClass = 'col-xs-6';
						break;
					default:
						vm.newsItemClass = 'col-xs-4';
						break;
				}
			}
		}

		function runReport(saveReport) {
			var backendUrl = HandbookConfiguration.BackendURL;
			var lastChar = backendUrl.charAt(backendUrl.length - 1);
			var commonAdd = lastChar == '/' ? '' : '/';
			if (saveReport.module == searchFilterTypes.handbookReports) {
				window.open(backendUrl + commonAdd + 'handbook/reportsView/param?' + saveReport.searchFilters, '_blank');
			} else {
				window.open(backendUrl + commonAdd + 'deviation/reports/param?' + saveReport.searchFilters, '_blank');
			}
		}

	};
})();

